import { filter } from 'rxjs/operators';
import Modal from '@roo/roo/Modal';

import {
    masterMessageHub as messageHub,
    PushCode,
    currentLoginWmPoiId,
    getWmPoiId,
} from '@services/messageHub/instance';

import * as LX from '@utils/lxWrapper';
import request from '@utils/axiosWrapper';

import store from '../../store';
import {
    addWeakNotification,
    ruleCenterSceneCodeLxSubject,
} from '../../connection/eventHandler/pushNotification';

const getReadReceiptConfigForRestScene = (sceneCode: any) => {
    if (sceneCode === 1) {
        LX.reportMV('b_waimai_e_mg20n10k_mv', 'c_waimai_e_skd9mojn');
        return {
            mc: 'b_waimai_e_mg20n10k_mc',
            cid: 'c_waimai_e_skd9mojn',
        };
    } else if (sceneCode === 2) {
        LX.reportMV('b_waimai_e_rlc49loz_mv', 'c_waimai_e_y62il3v6');
        return {
            mc: 'b_waimai_e_rlc49loz_mc',
            cid: 'c_waimai_e_y62il3v6',
        };
    }
    return undefined;
};

export default () => {
    // Code:2 营业状态变更
    messageHub
        .getPushSource(PushCode.POI_BUSINESS_STATUS_CHANGE_2)
        .pipe(
            filter(() => currentLoginWmPoiId !== '-1'), // 只有单店下处理
        )
        .subscribe(() => {
            setTimeout(() => {
                store.dispatch({ type: 'shellHeader/getBusinessStatus' });
            }, 500);
        });

    // Code: 8 客服(美团)置休
    messageHub.getPushSource(PushCode.CUSTOMER_SERVICE_SET_REST_8).subscribe(message => {
        if (message.setRest) {
            addWeakNotification({
                title: '置休通知',
                href: message.link_url || '/v2/shop/manage',
                linkText: message.link_text,
                wmPoiId: getWmPoiId(message),
                content: message.message.replace(/\+/g, ' '),
                wmEMsgTraceId: message.wmEMsgTraceId,
                wmEPoiMsgId: message.wmEPoiMsgId,
                readReceiptConfig: getReadReceiptConfigForRestScene(message.sceneCode),
            });
            setTimeout(() => {
                store.dispatch({ type: 'shellHeader/getBusinessStatus' });
            }, 500);
        }
        ruleCenterSceneCodeLxSubject.next(message.sceneCode);
    });

    // Code:10 配送调整营业时间对商家端造成影响的提示
    messageHub.getPushSource(PushCode.SHIPPING_TIME_CHANGE_10).subscribe(message => {
        addWeakNotification({
            title: '通知',
            content: message.message,
            href: '/v2/shop/manage/shopInfo',
            wmPoiId: getWmPoiId(message),
            wmEMsgTraceId: message.wmEMsgTraceId,
            wmEPoiMsgId: message.wmEPoiMsgId,
        });
    });

    // Code:13 商家心跳置休
    messageHub.getPushSource(PushCode.HEARTBEAT_SET_REST_13).subscribe(message => {
        addWeakNotification({
            title: '已被系统置休',
            content: message.message.replace(/\+/g, ' '),
            href: '/v2/shop/manage',
            wmPoiId: getWmPoiId(message),
            wmEMsgTraceId: message.wmEMsgTraceId,
            wmEPoiMsgId: message.wmEPoiMsgId,
        });
        request.postAsFormSubmit('/v2/common/heartbeat/w/log', { wmPoiId: getWmPoiId(message) });
        setTimeout(() => {
            store.dispatch({ type: 'shellHeader/getBusinessStatus' });
        }, 500);
    });

    // Code:14 手动置休
    messageHub.getPushSource(PushCode.NORMAL_SET_REST_14).subscribe(message => {
        addWeakNotification({
            title: '置休通知',
            content: message.message.replace(/\+/g, ' '),
            href: message.link_url || '/v2/shop/manage',
            linkText: message.link_text,
            wmPoiId: getWmPoiId(message),
            wmEMsgTraceId: message.wmEMsgTraceId,
            wmEPoiMsgId: message.wmEPoiMsgId,
            readReceiptConfig: getReadReceiptConfigForRestScene(message.sceneCode),
        });
        setTimeout(() => {
            store.dispatch({ type: 'shellHeader/getBusinessStatus' });
        }, 500);
        ruleCenterSceneCodeLxSubject.next(message.sceneCode);
    });

    // Code:21 排序特权到期提示
    messageHub.getPushSource(PushCode.POI_WEIGHTING_PRIVILEGE_21).subscribe(() => {
        Modal.confirm({
            title: '已成功开启新商家排序特权',
            children: '由于您的新商家免费排序特权即将过期，系统已自动为您开启，此特权为期7天哦',
            confirmText: '去看看',
            onConfirm: () => {
                window.location.hash = '/v2/newcome/privilegeInfo?flag=4';
            },
            cancelText: '知道了',
            onCancel: () => {
                if (window.location.href.indexOf('v2/index') !== -1) {
                    window.location.reload();
                }
            },
        });
    });
};
